import { isViMatched } from 'packages/utilities'

export const renderTagPlaceholder = (tags: string[]) => {
  return `+ ${tags.length}`
}

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  isViMatched(option?.label ?? '', input)
